import { memo, useMemo } from 'react';
import clsx from 'clsx';

import { Source, type Props as SourceProps } from './Source';

import skeletonStyles from '../../Sources/skeleton.module.css';
import styles from './source.module.css';

export const Skeleton = memo(({ total = 1, variant = 'normal', className }: Props) => {
  const fill = useMemo(() => Array.from({ length: total }).fill(null), [total]);
  return (
    <div className={styles.skeletonSources}>
      {fill.map((_, i) => (
        <Source
          key={i}
          aria-hidden
          variant={variant}
          sourceKey="In Progress"
          className={clsx(skeletonStyles.skeleton, className)}
        />
      ))}
    </div>
  );
});

interface Props extends Pick<SourceProps, 'variant'> {
  total?: number;
  className?: string;
}
